import { useUpdateKitsJob } from '@hooks/kits/useUpdateKitsJob';
import { useIsJobTimedOut } from '@hooks/useIsJobTimedOut';
import { isJobInProgress } from '@partful/pages/product-library/ui/product-list/jobFiltering';
import { KitsJob } from '@providers/job/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useKitsJobTimeoutHandler = (kitsJobData: KitsJob | undefined, accountId: string) => {
  const { t } = useTranslation('common');
  const { mutate: updateKitsJob } = useUpdateKitsJob();

  const hasJobTimedOut = useIsJobTimedOut(kitsJobData);
  const isInProgress = kitsJobData ? isJobInProgress(kitsJobData) : false;

  useEffect(() => {
    if (hasJobTimedOut && isInProgress) {
      updateKitsJob({
        runID: kitsJobData?.runID!,
        accountId,
        status: 'FAILED',
        errors: [{ source: 'vtaas-ui', message: `${t('kitsJobTimeoutError')}` }],
      });
    }
  }, [accountId, hasJobTimedOut, isInProgress, kitsJobData?.runID, t, updateKitsJob]);
};
